import React from "react";
import ScreenSelector from "@icarius-common/screenSelector";
import { getLocalizedString } from "@icarius-localization/strings";
import { AbsenceIcon, PermissionIcon, LicenceIcon } from "@icarius-icons/";
import paths from "@icarius-router/paths";

const IssueTypeSettings = () => {

  const data = [
    {
      name: getLocalizedString("absencesAlternative"),
      icon: <AbsenceIcon />,
      path: paths.absenceTypes,
    },
    {
      name: getLocalizedString("permissions"),
      icon: <PermissionIcon />,
      path: paths.permissionTypes,
    },
    {
      name: getLocalizedString("medicalLeaves"),
      icon: <LicenceIcon />,
      path: paths.licenceTypes,
    },
  ];

  return (
    <ScreenSelector
      title={getLocalizedString("issueTypesSettings")}
      data={data}
    />
  );
}

export default IssueTypeSettings;
